module.exports = __webpack_public_path__ + "img/coin-001.38d61d62.svg";